import * as React from 'react';
const SvgTable = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={120}
    height={120}
    fill="none"
    viewBox="0 0 120 120"
    {...props}
  >
    <circle cx={60} cy={60} r={60} fill="#E0EBFF" />
    <path
      fill="#0A2FFF"
      d="M100.369 60.625c.266-.987 1.728-.987 1.994 0l.139.517c.097.358.394.635.771.716l.29.063a.98.98 0 0 1 0 1.927l-.29.062a1.01 1.01 0 0 0-.771.716l-.139.518c-.266.987-1.728.987-1.994 0l-.139-.518a1.01 1.01 0 0 0-.77-.716l-.291-.062a.98.98 0 0 1 0-1.927l.29-.063c.377-.081.674-.358.771-.716z"
    />
    <circle cx={105.98} cy={53.884} r={1.5} fill="#85A3FF" />
    <path
      fill="#85A3FF"
      d="M55.754 6.868c.333-1.234 2.16-1.234 2.492 0l.174.646c.121.448.493.794.963.896l.363.078a1.224 1.224 0 0 1 0 2.408l-.363.079c-.47.101-.842.447-.963.895l-.174.647c-.332 1.234-2.16 1.234-2.492 0l-.174-.647a1.26 1.26 0 0 0-.963-.895l-.363-.079a1.224 1.224 0 0 1 0-2.408l.363-.078c.47-.102.842-.448.963-.896z"
    />
    <circle cx={65.25} cy={15.231} r={1.5} fill="#0A2FFF" />
    <circle cx={12.462} cy={41.769} r={1.5} fill="#C2D4FF" />
    <g filter="url(#a)" opacity={0.5}>
      <rect width={75} height={18.75} x={12} y={51.75} fill="#0014CC" rx={4} />
    </g>
    <rect width={75} height={21} x={12} y={49.5} fill="#fff" rx={4} />
    <rect width={21} height={4.5} x={34.5} y={54} fill="#85A3FF" rx={1} />
    <rect width={48} height={4.5} x={34.5} y={61.5} fill="#E0EBFF" rx={1} />
    <circle cx={23.25} cy={60} r={6.75} fill="#0014CC" />
    <g clipPath="url(#b)">
      <path
        fill="#F8F9FB"
        fillRule="evenodd"
        d="M23.252 56.381c.127 0 .244.072.301.187l.954 1.906 2.265.349a.338.338 0 0 1 .187.572l-1.567 1.566.35 2.269a.337.337 0 0 1-.49.35l-2-1.043-2 1.044a.338.338 0 0 1-.49-.351l.349-2.268-1.567-1.567a.337.337 0 0 1 .188-.572l2.265-.349.953-1.906a.34.34 0 0 1 .302-.187m0 1.093-.73 1.458a.34.34 0 0 1-.25.183l-1.78.274 1.217 1.216a.34.34 0 0 1 .095.29l-.274 1.779 1.565-.817a.34.34 0 0 1 .313 0l1.565.817-.274-1.779a.34.34 0 0 1 .095-.29l1.217-1.216-1.78-.274a.34.34 0 0 1-.25-.183z"
        clipRule="evenodd"
      />
    </g>
    <g filter="url(#c)" opacity={0.5}>
      <rect
        width={75}
        height={18.75}
        x={24.75}
        y={77.25}
        fill="#0014CC"
        rx={4}
      />
    </g>
    <rect width={75} height={21} x={24.75} y={75} fill="#fff" rx={4} />
    <rect width={21} height={4.5} x={47.25} y={79.5} fill="#85A3FF" rx={1} />
    <rect width={48} height={4.5} x={47.25} y={87} fill="#E0EBFF" rx={1} />
    <circle cx={36} cy={85.5} r={6.75} fill="#0014CC" />
    <g clipPath="url(#d)">
      <path
        fill="#F8F9FB"
        fillRule="evenodd"
        d="M36.002 81.881c.127 0 .244.073.301.187l.954 1.906 2.265.349a.338.338 0 0 1 .187.572l-1.567 1.567.35 2.268a.337.337 0 0 1-.49.35l-2-1.043-2 1.043a.338.338 0 0 1-.49-.35l.349-2.269-1.567-1.566a.337.337 0 0 1 .188-.572l2.264-.349.954-1.906A.34.34 0 0 1 36 81.88m0 1.093-.73 1.458a.34.34 0 0 1-.25.183l-1.78.274 1.217 1.216a.34.34 0 0 1 .095.29l-.274 1.779 1.565-.817a.34.34 0 0 1 .313 0l1.565.817-.274-1.779a.34.34 0 0 1 .095-.29l1.217-1.216-1.78-.274a.34.34 0 0 1-.25-.183z"
        clipRule="evenodd"
      />
    </g>
    <g filter="url(#e)" opacity={0.5}>
      <rect
        width={75}
        height={18.75}
        x={24.75}
        y={26.25}
        fill="#0014CC"
        rx={4}
      />
    </g>
    <rect width={75} height={21} x={24.75} y={24} fill="#fff" rx={4} />
    <rect width={21} height={4.5} x={47.25} y={28.5} fill="#85A3FF" rx={1} />
    <rect width={48} height={4.5} x={47.25} y={36} fill="#E0EBFF" rx={1} />
    <circle cx={36} cy={34.5} r={6.75} fill="#0014CC" />
    <g clipPath="url(#f)">
      <path
        fill="#F8F9FB"
        fillRule="evenodd"
        d="M36.002 30.881c.127 0 .244.072.301.187l.954 1.906 2.265.349a.338.338 0 0 1 .187.572l-1.567 1.566.35 2.269a.337.337 0 0 1-.49.35l-2-1.043-2 1.044a.338.338 0 0 1-.49-.351l.349-2.268-1.567-1.567a.337.337 0 0 1 .188-.572l2.264-.349.954-1.906A.34.34 0 0 1 36 30.88m0 1.093-.73 1.458a.34.34 0 0 1-.25.183l-1.78.274 1.217 1.216a.34.34 0 0 1 .095.29l-.274 1.779 1.565-.817a.34.34 0 0 1 .313 0l1.565.817-.274-1.779a.34.34 0 0 1 .095-.29l1.217-1.216-1.78-.274a.34.34 0 0 1-.25-.183z"
        clipRule="evenodd"
      />
    </g>
    <circle cx={60} cy={107.654} r={2.25} fill="#85A3FF" />
    <defs>
      <clipPath id="b">
        <path fill="#fff" d="M18.752 55.5h9v9h-9z" />
      </clipPath>
      <clipPath id="d">
        <path fill="#fff" d="M31.502 81h9v9h-9z" />
      </clipPath>
      <clipPath id="f">
        <path fill="#fff" d="M31.502 30h9v9h-9z" />
      </clipPath>
      <filter
        id="a"
        width={95}
        height={38.75}
        x={2}
        y={41.75}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_578_994"
          stdDeviation={5}
        />
      </filter>
      <filter
        id="c"
        width={95}
        height={38.75}
        x={14.75}
        y={67.25}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_578_994"
          stdDeviation={5}
        />
      </filter>
      <filter
        id="e"
        width={95}
        height={38.75}
        x={14.75}
        y={16.25}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_578_994"
          stdDeviation={5}
        />
      </filter>
    </defs>
  </svg>
);
export default SvgTable;
